import axios from "axios";

export function fetchUserPermissions(authToken) {
    const options = {
        headers: { 'x-auth-token': authToken }
    }

    console.log("Just Before sending permisions requewst!")
    return axios.get(process.env.REACT_APP_API_URL + '/users/permissions', options)
}